import { render, staticRenderFns } from "./OrdersCounters.vue?vue&type=template&id=2ad34e18&"
import script from "./OrdersCounters.vue?vue&type=script&lang=js&"
export * from "./OrdersCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports